import React, { useEffect } from 'react';
import { Box, Fab } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { NavigationBar } from './components';
import { WhatsApp } from '@mui/icons-material';

const PublicLayout = ({ mode }) => {

  const navigationBarHeight = 87;
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <NavigationBar mode={mode} navPosition="right" className="reveal-from-bottom" height={navigationBarHeight} />
      <Box style={{ width: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'flex-start', overflowX: "hidden" }}>
        <Outlet />
      </Box>
      <Fab
        onClick={() => window.open('https://wa.me/966581849999', '_blank')}
        color="success"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
        }}>
        <WhatsApp color="#24D366" />
      </Fab>
    </>
  )
}

export default PublicLayout;